// Admin session token storage.
//
// We deliberately use sessionStorage (not localStorage) so the admin token is
// cleared when the browser/tab closes. This narrows the exposure window if the
// device is left unattended or a persistent XSS ever ships. A short expiry
// wrapper adds a second layer: even inside an open session, the token becomes
// invalid after MAX_AGE_MS and forces a fresh login.

const KEY = 'aurelia_admin_session';
const MAX_AGE_MS = 8 * 60 * 60 * 1000; // 8 hours

export const readSession = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.issuedAt) return '';
    if (Date.now() - parsed.issuedAt > MAX_AGE_MS) {
      sessionStorage.removeItem(KEY);
      return '';
    }
    return parsed.token;
  } catch {
    return '';
  }
};

export const writeSession = (token) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, issuedAt: Date.now() }));
  } catch {
    // storage unavailable — token will simply not persist across reloads
  }
};

export const clearSession = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
};
